<template>
  <div class="table-box" v-loading="loading">
    <yx-table :data="data" :haspage="true" :page="page" @page-change="pageChange" :max-height="'300px'">
      <el-table-column prop="createTime" label="导入时间" width="160"></el-table-column>
      <el-table-column prop="exportTypeText" label="导入类型"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template #default="{ row }">
          {{ statusNames[row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="校区" :formatter="({ campusName }) => campusName || '-'"></el-table-column>
      <el-table-column prop="successCounts" label="导入成功" width="80"></el-table-column>
      <el-table-column prop="failCounts" label="导入失败" width="80"></el-table-column>
      <el-table-column label="操作" width="160" align="right">
        <template #default="scope">
          <div class="operate">
            <el-button type="text" v-if="scope.row.checkResultFile"
              @click="downloadFile(scope.row.checkResultFile)">失败名单</el-button>
            <span class="sp-line" v-if="scope.row.checkResultFile">|</span>
            <el-button type="text" @click="downloadFile(scope.row.originalFile)">原始文件</el-button>
          </div>
        </template>
      </el-table-column>
    </yx-table>
  </div>
</template>

<script>
import {
  defineComponent, ref, inject, onUnmounted,
} from 'vue';
import { formatDatetime } from '@teacher/common-lib/filters';

export default defineComponent({
  setup() {
    const api = inject('api');
    const loading = ref(false);
    const data = ref([]);
    const usePage = inject('usePage');
    const page = usePage();
    const statusNames = ref(['导入失败', '导入中', '导入完成']);
    function queryList(withLoading = false) {
      loading.value = withLoading;
      api
        .taskImportPage({ page })
        .then((res) => {
          if (res.code === 200) {
            data.value = res.data || [];
            data.value.forEach((item) => {
              const it = item;
              it.createTime = formatDatetime(it.createTime, 'yyyy-MM-dd hh:mm');
            });
            Object.assign(page, res.page);
          }
        })
        .finally(() => {
          loading.value = false;
        });
    }
    queryList(true);
    const timer = setInterval(queryList, 20000);
    onUnmounted(() => {
      clearInterval(timer);
    });
    return {
      loading,
      data,
      page,
      statusNames,
      queryList,
      pageChange(newPage) {
        Object.assign(page, newPage);
        queryList();
      },
      downloadFile(file) {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = file;
        document.body.appendChild(a);
        a.click();
      },
    };
  },
});
</script>

<style lang="scss" scoped>
.table-box {
  padding: 8px 0px;

  .operate {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .sp-line {
      color: var(--g4);
      margin: 0 5px;
    }
  }
}
</style>
